<div
  class="field-wrapper"
  fxLayout="row"
  fxLayoutAlign="start center"
  fxFlex="100%"
  [formGroup]="form"
  *ngIf="form"
>
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  <mat-form-field fxFlex floatLabel="always">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <span matPrefix *ngIf="prefix">{{ prefix }}</span>
    <input
      *ngIf="!isRequired"
      matInput
      autocomplete="off"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      [formControlName]="controlName"
      [placeholder]="placeholder"
    />
    <!-- Need it this way for screen readers D: -->
    <input
      *ngIf="isRequired"
      matInput
      autocomplete="off"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      [formControlName]="controlName"
      [placeholder]="placeholder"
      required
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <span matSuffix *ngIf="suffix">{{ suffix }}</span>
    <mat-hint align="start" *ngIf="hintStart">{{ hintStart }}</mat-hint>
    <mat-hint align="end" *ngIf="hintEnd">{{ hintEnd }}</mat-hint>
    <mat-error *ngIf="errors(control)">
      <mat-icon>error</mat-icon>
      {{ errors(control) }}
    </mat-error>
  </mat-form-field>
</div>
